import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import './Home.css'
import { API_IMAGES } from '../components/Include';

const Home = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  
  // Array of slider images
  const sliderImages = [

   
    API_IMAGES+"/website/slider/slide7.jpeg",
    API_IMAGES+"/website/slider/slide6.jpeg",
    API_IMAGES+"/website/slider/slide8.jpeg",
     API_IMAGES+"/website/slider/slide3.jpeg",
    API_IMAGES+"/website/slider/slide4.jpeg"
     ];

  // Auto-rotate slider images
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev === sliderImages.length - 1 ? 0 : prev + 1));
    }, 5000);
    
    return () => clearInterval(interval);
  }, [sliderImages.length]);
  return (
    <>
      {/* Hero Section */}
      <section className="hero-section">
        <div className="container">
          <div className="hero-content">
            <h1 className="hero-title">Entrepreneurship Development Center</h1>
            <h2 className="hero-subtitle">Nasarawa State University, Keffi</h2>
            <p className="hero-description">
              Empowering students with entrepreneurial skills and innovative mindsets for a successful future
            </p>
            <div className="hero-buttons">
              <Link to="/register" className="btn btn-primary hero-btn">
                <i className="ri-user-add-line me-2"></i>Get Started
              </Link>
              <Link to="/view-skills" className="btn btn-outline hero-btn">
                <i className="ri-tools-line me-2"></i>Explore Skills
              </Link>
            </div>
          </div>
        </div>
{/* Hero slider area */}
        <div className="hero-slider">
          {sliderImages.map((image, index) => (
            <div 
              key={index} 
              className={`slider-image ${index === currentSlide ? 'active' : ''}`}
              style={{ backgroundImage: `url(${image})` }}
            />
          ))}
          
          {/* Slider navigation dots */}
          <div className="slider-dots">
            {sliderImages.map((_, index) => (
              <button 
                key={index} 
                className={`slider-dot ${index === currentSlide ? 'active' : ''}`}
                onClick={() => setCurrentSlide(index)}
              />
            ))}
          </div>
        </div>
      </section>


 {/* Director's Welcome Section */}
 <section className="director-welcome-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">A message from our Director</h2>
          </div>
          <div className="director-welcome-container">
            <div className="director-image">
              <img src={API_IMAGES+"/website/directors/director2.jpeg"} alt="Director" />
              <div className="director-info">
                <h3>Prof. Rashidah Olanrewaju</h3>
                <p>Director, Entrepreneurship Development Center</p>
              </div>
            </div>
            <div className="director-message">
              <div className="message-content">
                <p className="welcome-text">
                  <span className="quote-mark">"</span>  Our center is dedicated to nurturing the entrepreneurial spirit and innovative mindset among our students.
                </p>
                <p>
                  At EDC, we believe that entrepreneurship is not just about starting businesses; it's about developing a mindset that sees opportunities where others see challenges. Our programs are designed to equip students with practical skills, knowledge, and networks necessary to thrive in today's competitive business environment.
                </p>
                <p>
                  Whether you're interested in launching a startup, innovating within an existing organization, or simply developing valuable skills for your career, EDC offers resources and support to help you achieve your goals. I invite you to explore our programs, engage with our community, and embark on your entrepreneurial journey with us.
                  <span className="quote-mark">"</span></p>
              </div>
            </div>
          </div>
        </div>
      </section>



   {/* Deputy Directors Section */}
   <section className="deputy-directors-section">
     <div className="container">
       <div className="section-header">
         <h2 className="section-title">Our Deputy Directors</h2>
       </div>
       
       <div className="deputy-directors-container">
         <div className="deputy-director-profile">
           <div className="profile-image">
             <img src={API_IMAGES+"/website/directors/deputy2.png"} alt="Deputy Director - Academic" />
           </div>
           <div className="profile-content">
             <h3> Dr. Ahmed Abdullahi Ibrahim</h3>
             <p className="position">Deputy Director, Academic Affairs</p>
             <p className="bio">Dr. Ahmed oversees academic programs and curriculum development at the Entrepreneurship Development Center. He is a Nigerian academic and seasoned scholar in Business Administration, currently serving in the Department of Business Administration at Nasarawa State University, Keffi.</p>
           
           </div>
         </div>
         
         <div className="deputy-director-profile">
           <div className="profile-image">
             <img src={API_IMAGES+"/website/directors/deputy2.jpeg"} alt="Deputy Director - Operations" />
           </div>
           <div className="profile-content">
             <h3>Dr. Aminu Mu’allimu Kambari</h3>
             <p className="position">Deputy Director, Operations & Partnerships</p>
             <p className="bio">Dr. Aminu leads our operational initiatives and strategic partnerships. His expertise in building industry connections has been instrumental in creating real-world opportunities for our students and graduates.</p>
            
           </div>
         </div>
       </div>
     </div>
   </section>


      {/* Features Section */}
      <section className="features-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Our Goal</h2>
             </div>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">
                <i className="ri-graduation-cap-line"></i>
              </div>
              <h3 className="feature-title">Quality Education</h3>
              <p className="feature-description">
                Learn from industry experts and experienced entrepreneurs through our comprehensive curriculum
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">
                <i className="ri-team-line"></i>
              </div>
              <h3 className="feature-title">Networking</h3>
              <p className="feature-description">
                Connect with like-minded individuals, mentors, and potential investors to grow your business
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">
                <i className="ri-lightbulb-line"></i>
              </div>
              <h3 className="feature-title">Innovation</h3>
              <p className="feature-description">
                Develop creative thinking and problem-solving skills to address real-world challenges
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">
                <i className="ri-rocket-line"></i>
              </div>
              <h3 className="feature-title">Career Growth</h3>
              <p className="feature-description">
                Enhance your employability and gain the skills needed to launch your own business
              </p>
            </div>
          </div>
        </div>
      </section>

     

      {/* Skill Acquisition Video Section */}
      <section className="video-section">
        <div className="container">
       
          <div className="full-video-container">
            <div className="video-wrapper">
              <iframe 
                src="https://www.youtube.com/embed/ddNsrD3FBb0?si=Zj7_-bV9H7FLMkWg" 
                title="INNOFEST 2.0" 
                frameBorder="0" 
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="testimonials-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Our Testimonial</h2>
          </div>
          <div className="testimonials-slider-container">
            <div className="testimonials-track">
              {/* First set of testimonials */}
              <div className="testimonial-card">
                <div className="testimonial-content">
                  <p className="testimonial-text">
                    "The EDC program completely changed my perspective on business. I gained practical skills that I use every day in my startup."
                  </p>
                </div>
                <div className="testimonial-author">
                  <div className="author-image">
                    <img src={API_IMAGES+"/website/facilitator/1.jpeg"} alt="Faridah Isah" />
                  </div>
                  <div className="author-info">
                    <h4 className="author-name">Faridah Isah</h4>
                    <p className="author-title">CEO, TechStart</p>
                  </div>
                </div>
              </div>

              <div className="testimonial-card">
                <div className="testimonial-content">
                  <p className="testimonial-text">
                    "I learned how to transform my passion into a profitable business through the EDC program. The hands-on approach to learning entrepreneurship made all the difference."
                  </p>
                </div>
                <div className="testimonial-author">
                  <div className="author-image">
                    <img src={API_IMAGES+"/website/facilitator/2.jpeg"} alt="Jane Smith" />
                  </div>
                  <div className="author-info">
                    <h4 className="author-name">Jane Smith</h4>
                    <p className="author-title">Founder, CreativeMinds</p>
                  </div>
                </div>
              </div>

              <div className="testimonial-card">
                <div className="testimonial-content">
                  <p className="testimonial-text">
                    "The mentorship I received at EDC was invaluable. They connected me with industry experts who helped me refine my business model and secure funding."
                  </p>
                </div>
                <div className="testimonial-author">
                  <div className="author-image">
                    <img src={API_IMAGES+"/website/facilitator/3.jpeg"} alt="Michael Johnson" />
                  </div>
                  <div className="author-info">
                    <h4 className="author-name">Michael Johnson</h4>
                    <p className="author-title">Founder, EcoSolutions</p>
                  </div>
                </div>
              </div>

              <div className="testimonial-card">
                <div className="testimonial-content">
                  <p className="testimonial-text">
                    "EDC provided me with a supportive community of like-minded entrepreneurs. The network I built there continues to be a source of inspiration and collaboration."
                  </p>
                </div>
                <div className="testimonial-author">
                  <div className="author-image">
                    <img src={API_IMAGES+"/website/facilitator/4.jpeg"} alt="Sarah Williams" />
                  </div>
                  <div className="author-info">
                    <h4 className="author-name">Sarah Williams</h4>
                    <p className="author-title">Co-founder, HealthTech Innovations</p>
                  </div>
                </div>
              </div>
              
              {/* Second set of testimonials for continuous scrolling effect */}
              <div className="testimonial-card">
                <div className="testimonial-content">
                  <p className="testimonial-text">
                    "The EDC program completely changed my perspective on business. I gained practical skills that I use every day in my startup."
                  </p>
                </div>
                <div className="testimonial-author">
                  <div className="author-image">
                    <img src={API_IMAGES+"/website/facilitator/1.jpeg"} alt="Faridah Isah" />
                  </div>
                  <div className="author-info">
                    <h4 className="author-name">Faridah Isah</h4>
                    <p className="author-title">CEO, TechStart</p>
                  </div>
                </div>
              </div>

              <div className="testimonial-card">
                <div className="testimonial-content">
                  <p className="testimonial-text">
                    "I learned how to transform my passion into a profitable business through the EDC program. The hands-on approach to learning entrepreneurship made all the difference."
                  </p>
                </div>
                <div className="testimonial-author">
                  <div className="author-image">
                    <img src={API_IMAGES+"/website/facilitator/2.jpeg"} alt="Jane Smith" />
                  </div>
                  <div className="author-info">
                    <h4 className="author-name">Jane Smith</h4>
                    <p className="author-title">Founder, CreativeMinds</p>
                  </div>
                </div>
              </div>

              <div className="testimonial-card">
                <div className="testimonial-content">
                  <p className="testimonial-text">
                    "The mentorship I received at EDC was invaluable. They connected me with industry experts who helped me refine my business model and secure funding."
                  </p>
                </div>
                <div className="testimonial-author">
                  <div className="author-image">
                    <img src={API_IMAGES+"/website/facilitator/3.jpeg"} alt="Michael Johnson" />
                  </div>
                  <div className="author-info">
                    <h4 className="author-name">Michael Johnson</h4>
                    <p className="author-title">Founder, EcoSolutions</p>
                  </div>
                </div>
              </div>

              <div className="testimonial-card">
                <div className="testimonial-content">
                  <p className="testimonial-text">
                    "EDC provided me with a supportive community of like-minded entrepreneurs. The network I built there continues to be a source of inspiration and collaboration."
                  </p>
                </div>
                <div className="testimonial-author">
                  <div className="author-image">
                    <img src={API_IMAGES+"/website/facilitator/4.jpeg"} alt="Sarah Williams" />
                  </div>
                  <div className="author-info">
                    <h4 className="author-name">Sarah Williams</h4>
                    <p className="author-title">Co-founder, HealthTech Innovations</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2 className="cta-title">Ready to Start Your Entrepreneurial Journey?</h2>
            <p className="cta-description">
            Semesterial skills Acquisition is exclusive for 200L and 300L students of the university. </p>
            <div className="cta-buttons">
              <Link to="/register" className="btn btn-primary cta-btn">
                Register Now
              </Link>
              <Link to="/verify-payment" className="btn btn-secondary cta-btn">
                Verify Payment
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Home